import React from 'react';
import { Route } from 'react-router-dom';
import Items from './userCoupons';

export default <Route path="/homepage/minhas-compras" component={Items} />;
